<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des gabarits de contrat"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :searchArgs="[
                            {
                                key: 'instance',
                                value: Mantle.FormTemplate.instanceContract
                            }
                        ]"
                :edit="dataEdit"
                root="/form-template/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/form-template"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du gabarit')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce gabarit?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'ContractTemplateList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Titre'),
                        key: 'title',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de création'),
                        key: 'creationDate',
                        type: 'date',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'title'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'title',
                            type: 'text',
                            label: Core.Definition.getDefinition('Titre'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                this.$router.push('/contrat/gabarits/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
